import { DASHBOARD_STATES } from '../constants/dashboardConstants';

/** The Created tab's filters with nothing applied. */
export const EMPTY_DASHBOARD_FILTERS = Object.freeze({
  search: '', state: '', sectionId: '', categoryId: '',
});

/**
 * Whether any Created-tab filter is applied.
 *
 * One definition for the page and the filter bar. They used to keep their own,
 * and the page's had no `categoryId`: a category that matched nothing read as
 * "no filters", so the page hid the bar — and with it the only way to clear
 * the category (CT-5468).
 */
export const hasActiveDashboardFilters = (filters = {}) => Boolean(
  filters.search || filters.state || filters.sectionId || filters.categoryId,
);

const timeOf = (value) => Date.parse(value) || 0;

/**
 * The Created tab's order: most recently changed first, archived at the end.
 *
 * `dashboard/list` is read one section at a time and merged (CT-5469), so
 * without this the list came out grouped by section, not by date. It keys on
 * `updatedAt` — the time each card shows, and the one `/list` actually sends;
 * `createdAt` is only ever its fallback.
 */
export const sortDashboards = (items = []) =>
  [...items].sort((a, b) => {
    const aArchived = a?.state === DASHBOARD_STATES.ARCHIVED;
    const bArchived = b?.state === DASHBOARD_STATES.ARCHIVED;
    if (aArchived !== bArchived) return aArchived ? 1 : -1;
    return timeOf(b?.updatedAt || b?.createdAt) - timeOf(a?.updatedAt || a?.createdAt);
  });
